module.exports = __webpack_public_path__ + "assets/scooter.ded781ce.svg";